<template>
    <BreadCrumb PageTitle="Substitution Mapping" />
    <QwilrSubstitutionMapping />
  </template>
  
  <script lang="ts">
  import { defineComponent } from "vue";
  
  import BreadCrumb from "../../components/Common/BreadCrumb.vue";
  import QwilrSubstitutionMapping from "../../components/Qwilr/QwilrSubstitutionMapping.vue";
  
  export default defineComponent({
    name: "QwilrSubstitutionMappingPage",
    components: {
      BreadCrumb,
      QwilrSubstitutionMapping,
    },
  });
  </script>